// extracted by mini-css-extract-plugin
module.exports = {"t1bfkwjz":"t1bfkwjz","cwktnue":"cwktnue"};